<template>
  <span class="text-white/50">COPYRIGHT © 2025 밀양스마트드림업. All RIGHTS RESERVED.</span>
</template>
